var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-pages"
  }, [_vm._v("\n  2021  ©  中平科技办公系统\n")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73988f07","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Bottom.vue
// module id = 63kC
// module chunks = 166